const buildConfig = (keyword, ext = {}) => {
  return {
    label: keyword, // 需要提示的关键字
    kind: 18, // 对应monaco.languages.CompletionItemKind.Text
    insertText: `${keyword}`, // 确认后输入的内容
    ...ext
  }
}

/**
 * 官方数组类型内建函数
 * 数据来源：http://freemarker.foofun.cn/ref_builtins_sequence.html
 * @author Caesar Liu
 * @date 2020-11-20 14:58
 */
module.exports = [
  buildConfig('chunk', {
    documentation: [
      '将数组划分为多个数组',
      '@param1: 子数组长度',
      '@param2: 子数组元素不够指定长度时的填充符(非必需)',
      'e.g: ',
      '<#assign seq = ["a", "b", "c", "d", "e", "f", "g"]>',
      '<#list seq?chunk(3, "-") as row>',
      '\t<#list row as cell>${cell} </#list>',
      '</#list>',
      '输出结果如下:',
      'a b c ',
      'd e f ',
      'g - - '
    ].join('\n')
  }),
  buildConfig('first', {
    documentation: [
      '返回数组的第一个元素。如果数组为空，那么模版处理将会中止。',
      'e.g: ${["red", "green", "blue"]?first} 返回"red"'
    ].join('\n')
  }),
  buildConfig('last', {
    documentation: [
      '返回数组的最后一个元素。如果数组为空，那么模版处理将会中止。',
      'e.g: ${["red", "green", "blue"]?last} 返回"blue"'
    ].join('\n')
  }),
  buildConfig('join', {
    documentation: [
      '指定分隔符将数组中的元素进行拼接',
      '@param 1: 分隔符',
      '@param 2: 空值，如果元素为空则使用该值',
      '@param 3: 列表结尾符号',
      'e.g 1: ${["a", "b"]?join("+")} 返回"a+b"',
      'e.g 2: ${["a", "b"]?join("+", "-", ".")} 返回"a+b."'
    ].join('\n')
  }),
  buildConfig('reverse', {
    documentation: [
      '返回数组的反序形式'
    ].join('\n')
  }),
  buildConfig('seq_contains', {
    documentation: [
      '判断数组中是否包含指定值',
      'e.g ${["a", "b"]?seq_contains("b")?then("Y", "N")}',
      '返回"Y"'
    ].join('\n')
  }),
  buildConfig('seq_index_of', {
    documentation: [
      '获取数组中指定值最先出现的索引',
      'e.g ${["a", "b"]?seq_index_of("b")}',
      '返回1'
    ].join('\n')
  }),
  buildConfig('seq_last_index_of', {
    documentation: [
      '获取数组中指定值最后出现的索引',
      'e.g ${["a", "b", "a"]?seq_last_index_of("a")}',
      '返回2'
    ].join('\n')
  }),
  buildConfig('size', {
    documentation: [
      '获取数组的长度',
      'e.g ${["a", "b", "a"]?size}',
      '返回3'
    ].join('\n')
  }),
  buildConfig('sort', {
    documentation: [
      '获取数组的升序形式'
    ].join('\n')
  }),
  buildConfig('sort_by', {
    documentation: [
      '获取数组的升序形式，用于在数组中均为对象时使用',
      'e.g:',
      '<#assign list=[{"no":3}, {"no": 2}]/>',
      '<#list list?sort_by("no") as item>',
      '${item.no}',
      '</#list>',
      '结果输出',
      '2',
      '3'
    ].join('\n')
  })
]
